import { CheckCircle } from "@phosphor-icons/react";

// Reusable editorial intro block for public feature pages (institutions, events, groups).
export function PageIntro({ title, tagline, intro = [], sections = [], closing, kicker }) {
  return (
    <section className="mt-8 rounded-2xl border border-border/60 bg-card p-6 sm:p-8" data-testid="page-intro">
      {title && <h2 className="font-heading text-2xl font-light tracking-tight">{title}</h2>}
      {tagline && <p className="mt-1 text-secondary">{tagline}</p>}
      <div className="mt-4 space-y-3">
        {intro.map((p, i) => <p key={i} className="leading-relaxed text-foreground/85">{p}</p>)}
      </div>
      {sections.length > 0 && (
        <div className="mt-6 space-y-5">
          {sections.map((s) => (
            <div key={s.heading} className="border-l-2 border-secondary/40 pl-4">
              <h3 className="flex items-center gap-2 font-heading text-base font-medium"><CheckCircle size={16} weight="fill" className="text-secondary" /> {s.heading}</h3>
              <p className="mt-1 leading-relaxed text-muted-foreground">{s.body}</p>
            </div>
          ))}
        </div>
      )}
      {closing && <p className="mt-6 font-heading text-lg font-light leading-snug">{closing}</p>}
      {kicker && <p className="mt-1.5 text-sm font-medium text-secondary">{kicker}</p>}
    </section>
  );
}
